import { useQuery } from '@tanstack/react-query';

import type { GetRiskAssessmentTemplatesParams } from 'api/RiskAssessmentTemplatesApi';
import { RiskAssessmentTemplatesApi } from 'api/RiskAssessmentTemplatesApi';
import { RISK_ASSESSMENT_TEMPLATES_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useRiskAssessmentTemplates(params?: GetRiskAssessmentTemplatesParams) {
  const riskAssessmentTemplatesApi = new RiskAssessmentTemplatesApi();
  const { userBankId } = useUser();

  const {
    data: riskAssessmentTemplates,
    isLoading: isLoadingRiskAssessmentTemplates,
    isError: isErrorRiskAssessmentTemplates
  } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [RISK_ASSESSMENT_TEMPLATES_KEY, userBankId, params],
    queryFn: () => riskAssessmentTemplatesApi.getRiskAssessmentTemplatesForBank(userBankId, params),
    meta: {
      snackbarErrorMessage:
        'There was an issue loading risk assessment templates. Please try again, or contact support if the problem persists.'
    }
  });

  return { riskAssessmentTemplates, isLoadingRiskAssessmentTemplates, isErrorRiskAssessmentTemplates };
}
